import React, { useState, useEffect } from 'react';
import { MODALS } from '../../../../config/images';
const ModalDelete = ({ showModalDelete, closeModal, accept, textType = "beneficio", pronoun = "el" }) => {

  const [isAccepted, setIsAccepted] = useState(false);

  useEffect(() => {
    setIsAccepted(false);
  }, [showModalDelete]);

  const handleAccept = () => {
    if (isAccepted) return;
    setIsAccepted(true);
    accept();
  };

  const handleClose = () => {
    setIsAccepted(false);
    closeModal();
  };

  if (!showModalDelete) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-full bg-black bg-opacity-50">
      <div className="lg:w-[23.33%] w-[85%] h-auto bg-white rounded-3xl shadow-lg flex flex-col pb-4  ">
        <div className='flex justify-end'>
          <button
            onClick={handleClose}
            className="px-4 py-2 rounded-md"
          >
            <img src={MODALS.CLOSE} alt="cerrar" />
          </button>
        </div>
        <div className='flex flex-col items-center justify-center gap-3 p-4 px-8'>
          <img src={MODALS.WARNING} alt="warning" />
          <div className='flex flex-col gap-4'>
            <p className="text-center text-md font-itcdemi">
              ¿Está seguro de borrar {pronoun} {textType}?
            </p>
            <p className="text-xs text-center font-itcbook">*Recuerde que al eliminar {pronoun} {textType} permanentemente no podrá recuperarlo.</p>
            <button
              onClick={handleAccept}
              disabled={isAccepted}
              className={`text-sm underline font-itcbook text-blue ${isAccepted ? 'opacity-50 cursor-not-allowed' : ''}`}>
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ModalDelete;
